export default __webpack_public_path__ + "static/media/element_62.71d71d60.jpg";